import { Link, useHistory } from "react-router-dom";
import React, { Fragment, useContext, useEffect, useState } from "react";
import axios from "axios";
import { translate } from "../../translations";

export default function Start() {
  const token = localStorage.getItem("token");
  const version = localStorage.getItem("version");
  const currentVersion = 10; //update this after new release
  const history = useHistory();
  const project = localStorage.getItem("currentProjectID");
  const [recordData, setRecordData] = useState({});
  async function getData() {
    const userRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/homeScreenText/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setRecordData(userRes.data[0] ? userRes.data[0].value : {});
  }

  const updateUserVersion = async () => {
    localStorage.setItem("version", currentVersion);

    history.go(0);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-center my-5">
        <div className="container flex justify-start w-full">
          <div className="flex flex-col grow">
            <div className="border-b border-gray-200  overflow-hidden sm:rounded-lg">
              <div className="py-12 bg-white">
                <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="lg:text-center">
                    {(!version || version < currentVersion) && (
                      <div
                        class="bg-red-100 mb-5 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                        role="alert"
                      >
                        <strong class="font-bold">
                          Indutec Service Manager 1.0 ist da!
                        </strong>
                        <span class="block sm:inline">
                          {" "}
                          Eine Übersicht über alle Änderungen findest du{" "}
                          <a href="/changelog">
                            <b>hier</b>
                          </a>
                          .
                        </span>
                        <button onClick={updateUserVersion}>
                          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
                            <svg
                              class="fill-current h-6 w-6 text-red-500"
                              role="button"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <title>Close</title>
                              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                            </svg>
                          </span>
                        </button>
                      </div>
                    )}

                    <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">
                      INDUTEC SERVICE MANAGER
                    </h2>
                    <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      {localStorage.getItem("currentProjectName")}
                    </p>
                    <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                      {translate("start_headline")}
                    </p>
                  </div>

                  <div className="mt-10">
                    <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                      <div className="relative">
                        <dt>
                          <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                              />
                            </svg>
                          </div>
                        </dt>
                        <dd
                          className="mt-2 ml-16"
                          dangerouslySetInnerHTML={{
                            __html: recordData.leftText,
                          }}
                        ></dd>
                      </div>
                      <div className="relative">
                        <dt>
                          <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                          </div>
                        </dt>
                        <dd
                          className="mt-2 ml-16"
                          dangerouslySetInnerHTML={{
                            __html: recordData.rightText,
                          }}
                        ></dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
